import React from "react";
import XDate from "xdate";
import Pikaday from "./Pickaday";
import { Icon, calendar } from "Icons/index";
import cx from "classnames";
import s from "./dayPicker.scss";

export default class DayPicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      format: "DD MM YYYY",
    };
  }

  handleChange = (date) => {
    this.props.onChange({ [this.props.name]: date });
  };

  render() {
    const { className, label, errors, value, name, disabled } = this.props;

    const rawValue = value;
    const formattedValue = rawValue ? new XDate(rawValue).toDate() : undefined;

    return (
      <div
        className={cx(className, s.dayPickerContainer, {
          [s.disabled]: disabled,
          [s.withErrors]: errors,
        })}
      >
        {label && (
          <div className={s.wrapLabel}>
            <label className={s.label} htmlFor={name}>
              {label || name.replace("_", " ")}
            </label>
          </div>
        )}
        <div className={s.wrapDatePicker}>
          <Pikaday
            value={formattedValue}
            onChange={this.handleChange}
            initialOptions={{ ...this.props }}
            disabled={disabled}
          />
          <Icon className={s.icon} svg={calendar} width="1rem" height="1rem" />
        </div>
        {errors && <div className={s.errorMsg}>{errors}</div>}
      </div>
    );
  }
}
